import { ShippingProfilesApiClient } from '@fourthwall/services/dist/ShippingProfilesApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useShippingProfileQuery = createQueryHook(
  ShippingProfilesApiClient.getShippingProfile,
  {
    queryKey: ['shippingProfile'],
  },
)
